<app-steps [step]='3'></app-steps>

<div class="row">
  <div class="col-sm-5">
    <div class="card floating shadow-lg">
      <div class="card-header">
        Validate Gift Voucher
      </div>
      <div class="card-body">
        <div class="row" *ngIf="app!=null && app.customer!=null">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Gift Voucher Number 1</mat-label>
              <input matInput [(ngModel)]="giftVoucherNumber1" type="text">
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Gift Voucher Number 2</mat-label>
              <input matInput [(ngModel)]="giftVoucherNumber2" type="text">
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Gift Voucher Amount Available</mat-label>
              <input matInput readonly class="text-right" [ngModel]="amountAvailable | currency:'$'"
                (ngModelChange)="onBrokenChangeAmountAvailable($event)" type="text">
            </mat-form-field>
          </div>
          <div class="col-12 text-center">
            <a class="btn btn-blue full-width" (click)='validate()'>Validate</a>
          </div>
        </div>
      </div>      
      <hr>
      <div class="card-footer">
          <div class="row">
              <div class="col-12">
                <a class="" (click)='goBackToPreviousPage()'>Back to checkout</a>
              </div>
          </div>
      </div>
    </div>
  </div>
  <div class="col-sm-7">
    <div class="card bg-transparent">

      <div class="card-body">
        <div class="row">
          <div class="col">
            <h3 class="card-title main-title">Redeem Gift Voucher</h3>
          </div>
        </div>
        <hr>
        <div class="row" *ngIf="app!=null && app.customer!=null">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Amount to be Pay</mat-label>
              <input matInput readonly class="text-right" [ngModel]="app.totalAmount | currency:'$'"
                (ngModelChange)="onBrokenChangeTotalAmount($event)" type="text">
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Redeemed Amount</mat-label>
              <input matInput readonly class="text-right" [ngModel]="redeemedAmount | currency:'$'"
                (ngModelChange)="onBrokenChangeRedeemedAmount($event)" type="text">
            </mat-form-field>
          </div>
          <div class="col-12" *ngIf="payableUsingPayPal>0">
            <mat-form-field appearance="outline">
              <mat-label>Payable using PayPal</mat-label>
              <input matInput readonly class="text-right" [ngModel]="payableUsingPayPal | currency:'$'"
                (ngModelChange)="onBrokenChangeRedeemedAmount($event)" type="text">
            </mat-form-field>
          </div>
          <div class="col-12 text-center">
            <a class="btn btn-blue full-width" *ngIf='!hidePayButton' (click)='pay()'>Pay</a>
            <a id="paypal-button-container" class="full-width"></a>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>